// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"xn-z","badgeLink":"yn-z","category":"zn-z"};